import React, { Component } from "react";
import "./REP.css";
import LanguageDropdown from '../../components/LanguageDropdown/LanguageDropdown';
import { Content } from './Content.js';
// Delete this import, the LanguagesTemp.js file, and the prop 'LanguageList' on the LanguageDropdown element once we have all languages translated
import { Languages } from './Languages.js'

function REP(props) {
    const [language, setLanguage] = React.useState("en");
    React.useEffect(
        () => {
            const lang = props.match.params.id;
            if (lang) setLanguage(lang);
        }, []);


    const handleOnChange = (event) => {
        setLanguage(event.target.value);
    };

    const RenderPageText = () => {
        return (
            <div className="col-sm-12 col-sm-offset-2" data-lang={language} dangerouslySetInnerHTML={{ __html: Content[language] }}>
            </div>
        );
    };

    return (
        <div className={["container-fluid", "privacy-page"].join(" ")}>
            <div className="privacy-toggle-bar">
                <a className="col-xs-8 back-button" style={{textAlign: 'left'}} role="button" href="javascript: window.history.back()">
                    <button className="btn btn-default btn-lg">
                        <span aria-hidden="true">&lt;</span>
                        <span className="sr-only">Back</span>
                    </button>
                </a>
                <div className="col-xs-8 right-align" style={{ visibility: 'hidden' }}>
                    <LanguageDropdown
                        onChange={handleOnChange}
                        LanguageList={Languages}
                    />
                </div>
            </div>
            <div className="row" data-lang={language}>
                <RenderPageText />
            </div>
        </div>
    );
}

export default REP;